import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './store'
import { zoomSdkApi } from './zoomSdkQueries'
import { Participants } from './types'
import { modifyParticipant } from 'src/utils/helpers'

type Meeting = {
  name?: string
  participants: Participants
  meetingId?: string
}

const initialState: Meeting = {
  participants: {},
}

const meetingSlice = createSlice({
  name: 'meeting',
  initialState,
  reducers: {
    updateParticipants: (state, { payload }: PayloadAction<Participants>) => {
      state.participants = payload
    },
  },
  extraReducers: (builder) => {
    // after s3 info is fetched, this goes next
    // this will trigger an update
    builder.addMatcher(
      zoomSdkApi.endpoints.getMeetingContext.matchFulfilled,
      (state, { payload: { meetingTopic, meetingID } }) => {
        state.name = state.name || meetingTopic
        state.meetingId = meetingID
      }
    )
    // after s3 info is fetched, this goes next
    // this will also trigger an update
    builder.addMatcher(
      zoomSdkApi.endpoints.getMeetingParticipants.matchFulfilled,
      (state, { payload: { participants } }) => {
        // change the shape of the data so it matches for the badges app info
        // compare current participants to ones already in order to merge
        participants.forEach((participant) => {
          const { screenName } = participant

          // if the participant does not yet exist, add them
          // if they do already exist, don't do anything
          if (!state.participants?.[screenName]) {
            state.participants[screenName] = modifyParticipant(participant)
          }
        })
      }
    )
    // this is the only way we can add the host, since the host is not returned by getMeetingParticipants
    builder.addMatcher(
      zoomSdkApi.endpoints.getUserContext.matchFulfilled,
      (state, { payload }) => {
        const { screenName, role } = payload
        if (role === 'host' && !state.participants?.[screenName]) {
          state.participants[screenName] = modifyParticipant(payload)
        }
      }
    )
  },
})

export const { updateParticipants } = meetingSlice.actions

export const selectMeetingParticipants = (state: RootState) =>
  state.meeting.participants
export const selectMeetingInfo = (state: RootState) => state.meeting

export default meetingSlice
